import store from "../store/index";

import Homepage from "../components/Pages/HomePage";
import LuminaireLineCreate from "../components/LuminaireLine/Create";
import LuminaireLineEdit from "../components/LuminaireLine/Edit";

import Login from "../components/Pages/Login";
import Register from "../components/Pages/Register";
import EditUser from "../components/Pages/EditAccount";
import ResetPassword from "../components/Pages/ResetPassword";
import ForgotPassword from "../components/Pages/ForgotPassword";
import UsersIndex from "../components/Users/Index";
import UsersShow from "../components/Users/Show";
import CustomerProjectsIndex from "../components/Projects/CustomerProjectsIndex";

import ProjectsIndex from "../components/Projects/Index";
import ProjectsShow from "../components/Projects/Show";

import PlanningsShow from "../components/Plannings/Show";
import PlanningsArrangeLuminaireLine from "../components/Plannings/ArrangeLuminaireLine";

export default {
    mode: 'history',
    routes: [

        {
            path: '/',
            component: Homepage,
            name: 'home',
            meta: {
                title: 'tempLED Produktkonfigurator',
            },
        },
        {
            path: '/templed-rayline',
            component: LuminaireLineCreate,
            name: 'templed-rayline',
            meta: {
                title: 'tempLED RayLine | Produktkonfigurator',
            },
        },

        // Project Routes
        {
            path: '/projekte',
            component: ProjectsIndex,
            name: 'projects.index',
            meta: {
                title: 'Projekte | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },
        {
            path: '/projekte/:id',
            component: ProjectsShow,
            name: 'projects.show',
            meta: {
                title: 'Projekt | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },

        // Planning Routes
        {
            path: '/lichtband/:id',
            component: PlanningsShow,
            name: 'plannings.show',
            meta: {
                title: 'Lichtband | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },
        {
            path: '/lichtband/:id/bearbeiten',
            component: LuminaireLineEdit,
            name: 'plannings.edit',
            meta: {
                title: 'Lichtband bearbeiten | tempLED Produktkonfigurator',
            },
        },
        {
            path: '/lichtband/:id/anordnung',
            component: PlanningsArrangeLuminaireLine,
            name: 'plannings.arrange',
            meta: {
                title: 'Lichtband anordnen | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },

        // Users

        {
            path: '/benutzer',
            component: UsersIndex,
            name: 'users.index',
            meta: {
                title: 'Benutzerliste | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },
        {
            path: '/benutzer/:id',
            component: UsersShow,
            name: 'users.show',
            meta: {
                title: 'Benutzer | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },
        {
            path: '/kundenprojekte',
            component: CustomerProjectsIndex,
            name: 'customerProjects.index',
            meta: {
                title: 'Kundenprojekte | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },

        // AUTH Routes
        {
            path: '/login',
            component: Login,
            name: 'login',
            meta: {
                title: 'Login | tempLED Produktkonfigurator',
            },
        },
        {
            path: '/registrierung',
            component: Register,
            name: 'register',
            meta: {
                title: 'Registrierung | tempLED Produktkonfigurator',
            },
        },
        {
            path: '/account',
            component: EditUser,
            name: 'users.edit',
            meta: {
                title: 'Account | tempLED Produktkonfigurator',
            },
            beforeEnter: requireLogin
        },
        {
            path: '/passwort-vergessen',
            component: ForgotPassword,
            name: 'users.forgotPassword',
            meta: {
                title: 'Passwort vergessen | tempLED Produktkonfigurator',
            },
        },
        {
            path: '/passwort-zuruecksetzen',
            component: ResetPassword,
            name: 'users.resetPassword',
            meta: {
                title: 'Passwort zurücksetzen | tempLED Produktkonfigurator',
            },
        },
    ],
}

function requireLogin(to, from, next) {

    if (store.state.auth.authenticated) {
        next(true);
    } else {
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        })
    }
}
